import React from "react";

const PricingTable = ({ plans }) => {
  return (
    <div className="relative font-inter antialiased ">
      <main className="relative min-h-screen flex flex-col justify-center  overflow-hidden">
        <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-24">
          <h2 className="text-center text-4xl font-bold mb-12 text-teal-600">
            Choose a Pricing Plan
          </h2>
          <div>
            <div className="max-w-sm mx-auto grid gap-6 lg:grid-cols-3 items-start lg:max-w-none">
              {plans.map((plan, index) => (
                <div key={index} className="h-full flex flex-col">
                  <div className="relative flex flex-col flex-grow p-6 rounded-2xl bg-gradient-to-br from-blue-400 via-teal-500 to-teal-400 border border-slate-200 shadow shadow-slate-950/5">
                    {plan.popular && (
                      <div className="absolute top-0 right-0 mr-6 -mt-4">
                        <div className="inline-flex items-center text-xs font-semibold py-1.5 px-3 bg-emerald-500 text-white rounded-full shadow-sm shadow-slate-950/5">
                          Most Popular
                        </div>
                      </div>
                    )}

                    {/* Plan Header */}
                    <div className="mb-5">
                      <div className="text-white font-bold text-2xl mb-1 text-center">
                        {plan.name}
                      </div>
                      <div className="text-sm text-white mb-5 text-center">
                        {plan.description}
                      </div>
                    </div>

                    {/* Button section: Ensure uniform height */}
                    <div className="flex-grow-0 mb-5">
                      <button class="w-full inline-flex justify-center whitespace-nowrap rounded-lg  z-30 px-3.5 py-2.5 bg-white hover:scale-105 hover:border hover:border-white   text-teal-500 relative font-medium after:-z-20 hover:text-white after:absolute after:h-1 after:w-1 after:bg-blue-400 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700  text-lg">
                        <a className=" " href="/contact">
                          Contact Us
                        </a>
                      </button>
                    </div>

                    {/* Spacer to ensure the button is aligned uniformly */}
                    <div className="flex-grow-0"></div>

                    {/* Plan Features */}
                    <div className="text-white font-medium mb-3">Includes:</div>
                    <ul className="text-white text-sm space-y-3">
                      {plan.features.map((feature, featureIndex) => (
                        <li key={featureIndex} className="flex items-center">
                          <svg
                            className="w-4 h-4 fill-emerald-200 mr-3 shrink-0"
                            viewBox="0 0 12 12"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                          </svg>
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PricingTable;
